var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.images && _vm.images.length > 0)?_c('el-image-viewer',{attrs:{"z-index":40100,"append-to-body":true,"on-close":_vm.closeViewer,"url-list":_vm.images}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }